import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Slot } from 'expo-router'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import { useTheme } from '@/contexts/ThemeContext'

export default function BlogLayout() {
  const { colors } = useTheme()

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    content: {
      flex: 1,
    },
  })

  return (
    <View style={styles.container}>
      <GlobalHeader />
      <View style={styles.content}>
        <Slot />
      </View>
      <GlobalFooter />
    </View>
  )
}
